var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('span',{staticClass:"fa-li"},[_c(_setup.Icon,{attrs:{"size":"xs","type":_setup.compIcon,"color":_setup.compColor}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }